import $ from 'jquery';
import {personalCashbackRest} from "../queries";

if ($('body').find('.header-basket__cashback')){
    (async () => {
       const response = await personalCashbackRest({})
           if(response.item && $('.header-basket__cashback-count')){
            $('.header-basket__cashback-count').text(response.item+ ' Б').css('display','flex').removeClass('header-basket__cashback-count--loading');


            if (response.item.toString().length > 3) {

             $('.header-basket__cashback-count').text(response.item.toString().substring(0, 3) + '...');
            }
               $('.page-personal-cashback-card__value').text(response.item);
               $('.page-personal-cashback-card__value').removeClass('page-personal-cashback-card__value--loading');
               $('.page-order-checkout__cashback--current b').text(response.item);
               if (parseInt(response.item)>0){
                   $('.page-order-checkout__cashback--checkbox').css('display','flex');
               }
           } else {
               $('.page-personal-cashback-card__value').text(0).removeClass('page-personal-cashback-card__value--loading');
               $('.header-basket__cashback-count').text('0 '+ 'Б').css('display','flex').removeClass('header-basket__cashback-count--loading')
           }
   })();
}

$('.header-user--counter').hover(function () {
    $('.header-user--icon i').css('color', '#32AAA7');
}, function (){
    $('.header-user--icon i').css('color', '');
});
